import { render, staticRenderFns } from "./ServiceRequestManageDetail.vue?vue&type=template&id=c92b5c28"
import script from "./ServiceRequestManageDetail.vue?vue&type=script&lang=js"
export * from "./ServiceRequestManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports